import { normaliseHex, themeFromBrand } from "@ternary/ui"
import { useEffect } from "react"
import { NEUTRAL_BRAND } from "./signup/neutral-brand.js"

/**
 * The browser's theme colour (a phone's browser bar) in the tenant's brand: its contrast-adjusted
 * primary, in the page's mode. A brand that is not a colour reads as the neutral brand, never
 * Ternary's green; no brand yet (the page still loading) sets nothing. index.html sets none.
 */
export function useThemeColor(
  brand: string | null | undefined,
  mode: "light" | "dark" = "light",
): void {
  useEffect(() => {
    if (!brand) return
    let meta = document.querySelector<HTMLMetaElement>('meta[name="theme-color"]')
    if (!meta) {
      meta = document.createElement("meta")
      meta.name = "theme-color"
      document.head.append(meta)
    }
    meta.content = themeFromBrand(normaliseHex(brand) ? brand : NEUTRAL_BRAND)[mode].primary
  }, [brand, mode])
}
